export default __webpack_public_path__ + "static/media/sts-4.d5aa8521.png";